<template>
  <div class="the-navbar__user-meta flex items-center">

    <div class="text-right leading-tight hidden sm:block" v-if="company">
      <p class="font-semibold" v-text="company"></p>
      <small  v-if="hasIdentity">Identity Mode</small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

      <div class="con-img">
        <vs-avatar :text="username | getFirstInitial | toUpperCase"/>
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">

          <router-link tag="li" class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" :to="{ name: 'my-account.personal-information' }">
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2" v-text="$t('profile')"></span>
          </router-link>

          <vs-divider class="m-1" />

          <li
            id="logoutButton"
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2" v-text="$t('logout')"></span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import http from '@/requests/http'
import UserHelper from '@/helpers/user'

export default {
  computed: {
    // TODO: Use or Delete
    // activeUserInfo () {
    //   return this.$store.state.AppActiveUser
    // }
    username () {
      return this.$store.getters.userInfo !== null ? this.$store.getters.userInfo.username : ''
    },
    company () {
      return this.$store.getters.userInfo !== null && this.$store.getters.userInfo.company !== null ? this.$store.getters.userInfo.company.name : ''
    },
    identity () {
      return this.$store.getters.identity
    },
    hasIdentity () {
      return this.identity !== null && this.identity !== ''
    }
  },
  methods: {
    async logout () {
      this.$vs.loading({background: '#fff', color: 'primary', container: '#logoutButton', scale: 0.45, type: 'sound'})

      if (this.hasIdentity) {
        try {
          const response = await http.post('identity/login', { id: this.identity })

          this.$store.dispatch('removeToken')
          if (response.data.user.id === this.identity) {
            this.$store.dispatch('removeIdentity') // Remove identity.
          }

          const userData = new UserHelper(response)
          await this.$store.dispatch('setToken', userData.getAccessToken())
          await this.$store.dispatch('setRefreshToken', userData.getRefreshToken())
          this.$store.dispatch('setUserInfo', userData.getUserData())

          window.location.replace(userData.getRedirectUrl())
          return
        } catch (e) {
          // TODO: Add custom loader for identity login
          this.$vs.loading.close('#logoutButton > .con-vs-loading')

          this.$swalHelper.displayCatchError({
            title: 'Error!',
            errorObject: e,
            confirmButton: this.$t('confirm')
          })

          return
        }
      }

      //  TODO: Delete Token Used. Put logout confirmation.
      this.$store.dispatch('removeToken')

      setTimeout(() => {
        if (this.username === 'user') {
          window.location.replace('/login?demo')
        } else {
          window.location.replace('/login')
        }
      }, 1000)
    }
  }
}
</script>

<style lang="scss">
  #logoutButton {
    position: relative;

    .con-vs-loading {
      position: absolute !important;
    }
  }
</style>
